import { Dropdown } from 'react-bootstrap';
import { css } from '@emotion/react';
import { hasNetworkSwitcher } from '@asset/themes/config';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { web3 } from '@state/web3';
import styled from '@emotion/styled';

const MenuCard = styled.div`
  border-radius: 5px;
  width: 100%;
  display: flex;
  justify-content: center;
`;

function NetworkSwitcher(): JSX.Element {
  /* Define state / hook */
  const { t } = useTranslation();
  const { _paramsChainId } = useParams();
  const navigate = useNavigate();
  const { chainList, chainId, address, provider, storeDefaultChainId } =
    web3.useContainer();

  const metaMaskProvider: any = provider?.provider;
  const paramsChainId = Number(_paramsChainId);

  /* Custom Data Object for render or other usages */
  const updateURLChainId = (newChainId: number) => {
    if (paramsChainId) {
      const { location } = window;
      const regex = new RegExp(`(/${paramsChainId}/|/${paramsChainId}$)`, 'g');
      const newLocation = (location.pathname + location.search).replace(
        regex,
        `/${newChainId}/`
      );
      navigate(newLocation, { replace: true });
    }
  };

  const switchChain = async (newChainId: number) => {
    await metaMaskProvider?.request({
      method: 'wallet_switchEthereumChain',
      params: [{ chainId: `0x${newChainId.toString(16)}` }],
    });
    storeDefaultChainId(newChainId);
    updateURLChainId(newChainId);
  };

  /* Render control function / logic */
  const handleSelect = async (network: string | null) => {
    const newChainId = Number(network);
    if (address && provider && network) {
      try {
        await switchChain(newChainId);
      } catch (switchError: any) {
        if (switchError.code === 4902) {
          try {
            const networkConfig = chainList?.find(
              (item) => item.chain_id === newChainId
            );
            await metaMaskProvider?.request({
              method: 'wallet_addEthereumChain',
              params: [
                {
                  chainId: `0x${newChainId.toString(16)}`,
                  chainName: networkConfig?.name,
                  rpcUrls: networkConfig?.rpc,
                  nativeCurrency: {
                    ...networkConfig?.native_currency,
                    decimals: Number(networkConfig?.native_currency?.decimals),
                  },
                  blockExplorerUrls: [networkConfig?.explorers[0]?.url],
                },
              ],
            });
            await switchChain(newChainId);
          } catch (addError: any) {
            //
          }
        }
      }
      return;
    }
    storeDefaultChainId(newChainId);
    updateURLChainId(newChainId);
  };

  /* Data Change Listeners - useEffect/useMemo/useCallback */

  /* Styling */

  /* Render */
  return chainList && hasNetworkSwitcher ? (
    <MenuCard className="menu_card">
      <Dropdown
        css={css`
          width: 100%;
        `}
        onSelect={handleSelect}
      >
        <Dropdown.Toggle
          css={css`
            padding: 0.8rem 3rem;
            font-size: 1.5rem;
            background-color: var(--primary-color);
            border-color: var(--primary-color9);
            border-radius: 5px;
            color: var(--primary-color2);
            overflow: hidden;
            text-overflow: ellipsis;
            width: 100%;

            @media (min-width: 992px) and (max-width: 1100px) {
              width: 150px;
            }
          `}
          id="dropdown-basic"
          variant="secondary"
        >
          {chainList?.find(
            (item) => item.chain_id === (paramsChainId || chainId)
          )?.name || t('header.notSupportedChain')}
        </Dropdown.Toggle>
        <Dropdown.Menu>
          {chainList?.map((item) => (
            <Dropdown.Item
              key={item.chain_id}
              eventKey={item.chain_id}
              href="#"
            >
              {item.name}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </MenuCard>
  ) : (
    <div />
  );
}

export default NetworkSwitcher;
